import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "./styles/ListadoEVS.css";

class ListadoEVS extends Component {


    render() {
        const { user } = this.props;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="configuraciones_activo"
                    titulo="EVS"
                    subtitulo="Del sistema"
                    noBorder
                >
                    <Listado storageKey="historico_inventarios_state" />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(ListadoEVS);
